import { render, staticRenderFns } from "./SalaryTaxes.vue?vue&type=template&id=7a4701c3&scoped=true&"
import script from "./SalaryTaxes.vue?vue&type=script&lang=js&"
export * from "./SalaryTaxes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a4701c3",
  null
  
)

export default component.exports